/**
 * Run Matomo instance.
 *
 * @since 0.1.0
 */
(function() {
	var   _paq             = window._paq = window._paq || [];
	var   analytics        = maiPubAnalyticsVars.analytics;
	var   analyticsPrimary = analytics[0];
	var   analyticsMore    = analytics.slice(1);
	const debug            = window.location.search.includes('dfpdeb') || window.location.search.includes('maideb') || window.location.search.includes('pbjs_debug=true');
	const log              = 'undefined' !== typeof maiPubAdsVars ? maiPubAdsVars.debug : false;
	const timestamp        = Date.now(); // For maiPubAnalyticsLog() timing.
	const identityWaitMs   = 3000; // The most the pageview waits for the ads script's identity dimensions (maiPubWhenIdentity).

	/**
	 * Sets up trackers.
	 */
	(function() {
		_paq.push( [ 'setTrackerUrl', analyticsPrimary.url + 'matomo.php' ] );
		_paq.push( [ 'setSiteId', analyticsPrimary.id ] );

		for ( const key in analyticsMore ) {
			_paq.push( [ 'addTracker', analyticsMore[ key ].url + 'matomo.php', analyticsMore[ key ].id ] );
		}

		var d = document,
			g = d.createElement( 'script' ),
			s = d.getElementsByTagName( 'script' )[0];

		g.async = true;
		g.src   = analyticsPrimary.url + 'matomo.js';
		s.parentNode.insertBefore( g, s );
	})();

	/**
	 * Called by matomo.js once it has loaded.
	 */
	window.matomoAsyncInit = function() {
		maiPubWhenIdentity( maiPubInitTrackers );
	};

	/**
	 * Runs cb once window.maiPubIdentity is set, or won't be.
	 *
	 * The identity dimensions (arrival, identity tier) only count on the pageview itself
	 * (see maiPubInitTrackers()), and mai-publisher-ads.js publishes them when it runs.
	 * Both scripts are async, and Matomo can be ready first: on the first pageview after a
	 * release (both plugin scripts downloaded again, matomo.js still cached), or on a slow
	 * phone. That pageview went out without them. So while the ads script is on the page
	 * and hasn't run, the pageview waits for it: until it has run, has failed to load (an
	 * ad blocker), the page is hidden or left, or identityWaitMs. class-output.php prints the
	 * watch (window.maiPubAdsScript) before the ads script. A page without it, or where the
	 * ads script ran first, doesn't wait.
	 *
	 * @since TBD
	 *
	 * @param {Function} cb Sets up the trackers and tracks the pageview.
	 *
	 * @return {void}
	 */
	function maiPubWhenIdentity( cb ) {
		const watch = window.maiPubAdsScript;

		if ( 'undefined' !== typeof window.maiPubIdentity || ! watch || watch.done ) {
			cb();
			return;
		}

		const start = Date.now();
		let   timer = null;
		let   ran   = false;
		const run   = ( why ) => {
			if ( ran ) {
				return;
			}
			ran = true;
			clearTimeout( timer );
			document.removeEventListener( 'maiPubAdsScriptDone', onDone );
			document.removeEventListener( 'visibilitychange', onHidden );
			window.removeEventListener( 'pagehide', onLeave );
			maiPubAnalyticsLog( `Matomo: waited ${ Date.now() - start }ms for the ads script (${ why }); identity dimensions ${ 'undefined' !== typeof window.maiPubIdentity ? 'set' : 'not set' }.` );
			cb();
		};
		const onDone   = () => run( 'it ran or failed to load' );
		const onHidden = () => { if ( 'hidden' === document.visibilityState ) { run( 'the page was hidden' ); } };
		const onLeave  = () => run( 'the page is being left' );

		document.addEventListener( 'maiPubAdsScriptDone', onDone );
		document.addEventListener( 'visibilitychange', onHidden );
		window.addEventListener( 'pagehide', onLeave );
		timer = setTimeout( () => run( 'timed out' ), identityWaitMs );
	}

	/**
	 * Sets up each tracker and tracks the pageview.
	 */
	function maiPubInitTrackers() {
		// Dispatch custom event before processing analytics.
		const event = new CustomEvent( 'beforeMaiPublisherAnalytics', {
			detail: maiPubAnalyticsVars,
			cancelable: true
		});
		document.dispatchEvent( event );

		// Continue with existing tracker code
		for ( const tracker in analytics ) {
			try {
				const matomoTracker = Matomo.getTracker( analytics[ tracker ].url + 'matomo.php', analytics[ tracker ].id );

				// Attach the resolved identity dimensions (arrival, identity tier)
				// to THIS tracker BEFORE trackPageView is replayed below, so they
				// ride the pageview request itself. mai-publisher-ads.js resolves
				// them once from client-side signals and exposes an index -> value
				// map on window.maiPubIdentity (the index numbers live there, not
				// here). Delivering them on the pageview — rather than a later ping
				// (which does not persist custom dimensions) or a trackEvent (which
				// would add an action) — is what records them without disturbing
				// Actions-per-Visit or Bounce Rate. Present only on pages that load
				// the ads bundle, where identity resolves; elsewhere they are
				// simply not set.
				if ( 'undefined' !== typeof window.maiPubIdentity && window.maiPubIdentity.matomoDimensions && 'function' === typeof matomoTracker.setCustomDimension ) {
					for ( const dimId in window.maiPubIdentity.matomoDimensions ) {
						const dimVal = window.maiPubIdentity.matomoDimensions[ dimId ];

						if ( dimVal ) {
							matomoTracker.setCustomDimension( parseInt( dimId, 10 ), dimVal );
						}
					}
				}

				// The display split this pageview is in ('magnite', 'reviq', 'catalyst' or
				// 'none'), for revenue per pageview by wrapper. Action scope, so each
				// pageview carries its own (the split is sticky for an hour, not a visit):
				// unlike the identity dimensions above, it's decided in <head> by
				// mai-publisher-split.js, before Matomo loads, so it's always here in time.
				if ( maiPubAnalyticsVars.adWrapperDimension && window.maiPubDisplaySplit && window.maiPubDisplaySplit.wrapper && 'function' === typeof matomoTracker.setCustomDimension ) {
					matomoTracker.setCustomDimension( maiPubAnalyticsVars.adWrapperDimension, window.maiPubDisplaySplit.wrapper );
				}

				// Loop through and push items.
				for ( const key in analytics[ tracker ].toPush ) {

					var func = analytics[ tracker ].toPush[ key ][0];
					var vals = analytics[ tracker ].toPush[ key ].slice(1);
					    vals = vals ? vals : null;

					if ( vals ) {
						matomoTracker[func]( ...vals );
					} else {
						matomoTracker[func]();
					}
				}

				// Dispatch custom event after processing analytics.
				const trackerEvent = new CustomEvent( 'maiPublisherAnalyticsInit', {
					detail: {
						tracker: matomoTracker,
					},
					cancelable: true
				});
				document.dispatchEvent(trackerEvent);

				// If we have an ajax url and body, update the views.
				if ( analytics[ tracker ].ajaxUrl && analytics[ tracker ].body ) {
					// Send ajax request.
					fetch( analytics[ tracker ].ajaxUrl, {
						method: "POST",
						credentials: 'same-origin',
						headers: {
							'Content-Type': 'application/x-www-form-urlencoded',
							'Cache-Control': 'no-cache',
						},
						body: new URLSearchParams( analytics[ tracker ].body ),
					})
					.then(function( response ) {
						if ( ! response.ok ) {
							throw new Error( response.statusText );
						}

						return response.json();
					})
					.then(function( data ) {
					})
					.catch(function( error ) {
						maiPubAnalyticsLog( error );
					});
				}

			} catch( error ) {
				maiPubAnalyticsLog( error );
			}
		}
	}

	/**
	 * Log if debugging.
	 *
	 * @param {mixed} mixed The data to log.
	 *
	 * @return {void}
	 */
	function maiPubAnalyticsLog( ...mixed ) {
		if ( ! ( debug || log ) ) {
			return;
		}

		// Set log variables.
		let timer = 'maipub analytics ';

		// Set times.
		const current = Date.now();
		const now     = new Date().toLocaleTimeString( 'en-US', { hour12: true } );

		// If first, start.
		if ( timestamp === current ) {
			timer += 'start';
		}
		// Not first, add time since.
		else {
			timer += current - timestamp + 'ms';
		}

		// Log the combined message.
		console.log( `${timer} ${now}`, mixed );
	}
})();
